import { z } from 'zod'
import { ProductSubItemStatus } from '~/enums/product-sub-item-status'
import {
  createProductSubItemRequestSchema,
  createProductSubRequestSchema
} from './create-product-sub-request'

/**
 * 產品子類目 - 子網頁分類（更新）Schema
 */
const updateProductSubItemSchema = createProductSubItemRequestSchema.merge(
  z.object({
    /** 產品子網頁分類 ID */
    psiID: z.number().optional(),
    /** 產品子類目 ID */
    psID: z.number().optional(),
    /** 狀態 */
    status: z.nativeEnum(ProductSubItemStatus),
    /** 資料排序 */
    dataIndex: z.number().optional()
  })
)

/**
 * 產品子類目 - 更新 Request Schema
 */
export const updateProductSubRequestSchema = createProductSubRequestSchema
  .partial()
  .merge(
    /** 子網頁分類 */
    z.object({
      items: z.array(updateProductSubItemSchema).optional()
    })
  )

/**
 * 產品子類目 - 更新 Request
 */
export interface UpdateProductSubRequest
  extends z.infer<typeof updateProductSubRequestSchema> {}
